import { IPanel, LinkActionSchema } from "smarthub-common";

export const darcieChatPanel: IPanel = {
  $id: "panel.chat",
  $schema: "https://ics.ai/smarthub/panel",
  group: "panels.intranet",
  description: "Chat transcript and controls",
  title: "Chat",
  shortTitle: "chat",
  icon: {
    name: "Chat",
  },
  order: 1,
  initialFocus: "chat-controls",
  navigation: "none",
  menu: {
    $id: "component.chat-menu",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-menu",
    title: "Chat menu",
    description: "Choose display settings",
  },
  header: {
    $id: "component.chat-header",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat header",
    description: "Chat header",
    template: "component.chat-header",
  },
  splash: {
    $id: "component.chat-splash",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat splash",
    description: "Chat splash",
    template: "component.chat-splash",
    props: {
      enabled: true,
      mode: "implicit",
      cacheLocation: "session",
      version: "1.0",
      sessionKey: "customer.ai-flex-chat-tnc-acceptance",
      config: {
        html: "<p>Hi, I'm Darcie, Derby City Council's digital helper. I'm here to help you with any questions you have about our services.</p><p>To get the best answers, please phrase your questions in a sentence using four words or more.</p><p>If you don't get the answer you're looking for, try typing your question a different way.</p><p>I'm always learning, so please let me know about your experience by leaving a comment in the 'rate my result' box.  Your feedback will help me improve your future experience.</p><p>Find out more about me on our website: <b><u><a href='https://www.derby.gov.uk/contact-the-council/' target='_blank'>https://www.derby.gov.uk/contact-the-council/</a></u></b></p><p>To start chatting, choose 'Continue' below to confirm you have read and understood our <b><u><a href='https://www.derby.gov.uk/site-info/privacy-notices/' target='_blank'>privacy policy.</a></u></b></p>",
        buttons: {
          primaryButtonHoverTextColor: "#333",
          secondaryButtonHoverTextColor: "#333",
        },
      },
    },
  },
  footer: {
    $id: "component.chat-footer",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat footer",
    description: "Chat footer",
    template: "component.chat-footer",
    props: {
      actions: [
        {
          name: "privacy",
          title: "View the privacy statement on our website",
          shortTitle: "Privacy Statement",
          description: "Open the webchat privacy statement on our website",
          action: {
            $id: "",
            $schema: LinkActionSchema,
            uri: "https://www.derby.gov.uk/site-info/privacy-notices/",
          },
        },
      ],
    },
  },
  templates: [
    {
      $id: "template.chat",
      $schema: "https://ics.ai/smarthub/template",
      description: "Darcie chat transcript and controls",
      title: "Darcie chat",
      shortTitle: "Chat",
      group: "templates.intranet",
      tabs: [
        {
          $id: "layout.chat",
          $schema: "https://ics.ai/smarthub/tab",
          description: "Ali chat transcript and controls.",
          group: "tabs.intranet",
          title: "Chat",
          shortTitle: "Chat",
          icon: {
            name: "Chat",
          },
          body: {
            grid: {
              tokens: {
                padding: "none",
              },
              rows: [
                {
                  responsive: {
                    sm: { scroll: true, stretch: true },
                  },
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.main",
                        },
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.controls",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            zones: [
              {
                id: "zone.main",
                components: [
                  {
                    $id: "component.chat-transcript",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat conversation",
                    template: "component.chat-transcript",
                  },
                ],
              },
              {
                id: "zone.controls",
                components: [
                  {
                    $id: "component.chat-controls",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat controls",
                    template: "component.chat-controls",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
